<template>
  <fieldset class="filters__boolean">
    <v-checkbox
      v-model="params[type]"
      @change="applyFilter"
      :label="label"
      hide-details
    />
  </fieldset>
</template>

<script>
import { mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'FilterBoolean',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    label: {
      type: String,
      default: 'Filtro',
    },

    type: {
      type: String,
      require: true,
    },
  },

  data() {
    return {
      params: {},
    }
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    applyFilter() {
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...this.params })
      )
        .then(() => this.setCurrentPage(1))
        .then(() => this.fetchData())
    },
  },
}
</script>
